module.exports = __webpack_public_path__ + "img/safety.87dd37dc.svg";